<template>
	<div class="receivingTime-body">
        <div class="fx-header">
			<p>收货时间</p>
		</div>
        <div class="time-box">
            <el-select placeholder="" v-model="startH" class="select-box" size='small'>
                <el-option v-for="(item,index) in hList" :key='index' :value="item.val" :label="item.val"></el-option>
            </el-select>时
             <el-select placeholder="" v-model="startM" class="select-box" size='small'>
                <el-option value="00" label="00"></el-option>
                <el-option value="30" label="30"></el-option>
            </el-select>分
            <span style="margin:0 20px">—</span>
            <el-select placeholder="" @change="endHChange" v-model="endH" class="select-box" size='small'>
                <el-option v-for="(item,index) in hList" :key='index' :value="item.val" :label="item.val"></el-option>
            </el-select>时
             <el-select placeholder="" v-model="endM" class="select-box" size='small'>
                <el-option value="00" label="00"></el-option>
                <el-option value="30" label="30"></el-option>
				<el-option v-if='endH === "23"' value="59" label="59"></el-option>
            </el-select>分
            <el-button type='primary' plain size='mini' class="fx-btn" @click="addClick">添加时间段</el-button>
        </div>
        <div class="line-box">
			<div class="pic-box">
				<div class="midNight-box">
					<img style="float:left" src="~/images/icon/midNight.png" />
					<span style="float:left;line-height:25px;margin:0px 10px;font-weight: bold">午夜</span>
					<img style="float:left;margin-top:8px" src="~/images/icon/dottedLine.png" />
				</div>
				<div class="beforeDawn-box">
					<img style="float:left" src="~/images/icon/beforeDawn.png" />
					<span style="float:left;line-height:25px;margin:0px 10px;font-weight: bold">凌晨</span>
					<img style="float:left;margin-top:8px" src="~/images/icon/dottedLine.png" />
				</div>
				<div class="day-box">
					<img style="float:left" src="~/images/icon/day.png" />
					<span style="float:left;line-height:25px;margin:0px 10px;font-weight: bold">中午</span>
					<img style="float:left;margin-top:8px" src="~/images/icon/dottedLine.png" />
				</div>
				<div class="night-box">
					<img style="float:left" src="~/images/icon/night.png" />
					<span style="float:left;line-height:25px;margin:0px 10px;font-weight: bold">晚间</span>
					<img style="float:left;margin-top:8px" src="~/images/icon/dottedLine.png" />
				</div>
			</div>
            <div class="left">
                <el-timeline>
                    <el-timeline-item
                    v-for="(activity, index) in activities"
                    :key="index"
                    :color="$fxPrimaryColor"
                    size="large">
                        {{activity.content}}
                    </el-timeline-item>
                </el-timeline>
            </div>
            <div class="mid">
                <div v-for='(item,index) in divList' :key='index' :style="'top:'+item.top+'px;height:'+item.height+'px;line-height:'+item.height+'px;background-color:var(--fx-primary-color);position: absolute;width:10px;border-radius:5px'">
                </div>
            </div>
            <div class="right">
                <div v-for='(item,index) in divList' :key='index' :style="'top:'+item.top+'px;height:'+item.height+'px;line-height:'+item.height+'px;position: absolute'">
                    {{item.startdate}} —— {{item.enddate}}
					<div style="display:inline-block;cursor: pointer;position:relative;top:3px;margin-left:10px">
						<img src="~/images/icon/del.png" @click="divDel(index)" />
					</div>
                </div>
            </div>
        </div>
        <div class="button-box">
            <el-button plain size='mini' class="fx-big-btn" @click="cancelClick">取消</el-button>
            <el-button type='primary' size='mini' class="fx-big-btn" @click="saveClick">保存</el-button>
        </div>
		<el-dialog top='60px' class="dialog-title" title="提示" :close-on-click-modal='false' :visible.sync="waringModal" width='500px'>
			<div style="max-height:150px;overflow-y :auto">
				【{{shopNameList}}】进行了送货时间管理，只有关闭店铺的送货时间管理，才可以添加收货时间。是否要自动关闭【{{shopNameList}}】的送货时间管理？
			</div>
			<div style="width:100%;text-align:center;margin-top:10px">
				<el-button style="width:100px" plain size='small' @click="cancelWaring">否</el-button>
				<el-button style="width:100px" type='primary' plain size='small' @click="saveWaring">是</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	name: 'receivingTime',
	components: {
	},
	data () {
		return {
			hList: [
				{ val: '00' },
				{ val: '01' },
				{ val: '02' },
				{ val: '03' },
				{ val: '04' },
				{ val: '05' },
				{ val: '06' },
				{ val: '07' },
				{ val: '08' },
				{ val: '09' },
				{ val: '10' },
				{ val: '11' },
				{ val: '12' },
				{ val: '13' },
				{ val: '14' },
				{ val: '15' },
				{ val: '16' },
				{ val: '17' },
				{ val: '18' },
				{ val: '19' },
				{ val: '20' },
				{ val: '21' },
				{ val: '22' },
				{ val: '23' }
			],
			shopNameList: '',
			waringModal: false,
			flag: 0,
			disabledSM: false,
			disabledEM: false,
			AuthorityList: {

			},
			divList: [],
			startH: '',
			startM: '',
			endH: '',
			endM: '',
			activities: [
				{
					content: '00'
				}, {
					content: '02'
				}, {
					content: '04'
				}, {
					content: '06'
				}, {
					content: '08'
				}, {
					content: '10'
				}, {
					content: '12'
				}, {
					content: '14'
				}, {
					content: '16'
				}, {
					content: '18'
				}, {
					content: '20'
				}, {
					content: '22'
				}, {
					content: '24'
				}
			]
		}
	},
	created () {
		this.getTimeList()
	},
	methods: {
		endHChange () {
			if (this.endH !== '23' && this.endM === '59') {
				this.endM = ''
			}
		},
		cancelWaring () {
			this.waringModal = false
		},
		saveWaring () {
			this.waringModal = false
			this.saveClick()
		},
		checkSave () {
			let params = {
				startDate: [],
				endDate: []
			}
			if (this.divList.length > 0) {
				let list = this.divList
				for (let i = 0; i < list.length; i++) {
					params.startDate.push(list[i].startdate)
					params.endDate.push(list[i].enddate)
				}
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/takeDeliveryTime/isManageSendTime`,
				data: params
			}).then(res => {
				if (res.result) {
					if (res.data.result) {
						this.shopNameList = res.data.message
						this.waringModal = true
					} else {
						this.saveClick()
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		clearTime () {
			this.startM = ''
			this.startH = ''
			this.endH = ''
			this.endM = ''
		},
		cancelClick () {
			this.clearTime()
			this.getTimeList()
		},
		saveClick () {
			let params = {
				startDate: [],
				endDate: []
			}
			if (this.divList.length > 0) {
				let list = this.divList
				for (let i = 0; i < list.length; i++) {
					params.startDate.push(list[i].startdate)
					params.endDate.push(list[i].enddate)
				}
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/takeDeliveryTime/save`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功!')
					this.clearTime()
					this.getTimeList()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		getTimeList () {
			this.divList = []
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/takeDeliveryTime/list`
			}).then(res => {
				if (res.result) {
					if (res.data.length > 0) {
						this.timeToScale(res.data)
					}
				}
			})
		},
		addClick () {
			if (this.startH === '' || this.startM === '' || this.endH === '' || this.endM === '') {
				this.$message.error('请选择正确时间段')
				return false
			}
			this.flag = 0
			let startTime = this.startH + ':' + this.startM
			let endTime = this.endH + ':' + this.endM
			let dataList = [{ 'startdate': startTime, 'enddate': endTime, 'top': '', 'height': '' }]
			let [data] = dataList
			this.checkTime(data)
			if (this.flag === null) {
				this.$message.error('请选择正确时间段')
				return false
			}
			if (this.flag > 0) {
				// this.$alert('选择时间段和已有时间段冲突，请重新选择', '提示', {
				// 	confirmButtonText: '确定',
				// 	callback: action => {
				// 	}
				// })
				this.$message.error('选择时间段和已有时间段冲突，请重新选择')
				return false
			}
			this.timeToScale(dataList)
			this.$message.success('添加成功')
		},
		checkTime (data) {
			let start = 0
			let end = 0
			let startTime = data.startdate.split(':')
			let start0 = +startTime[0]
			let start1 = 0
			if (startTime[1] === '00') {
				start1 = 0
			} else if (startTime[1] === '30') {
				start1 = 0.5
			}
			start = (start0 + start1) * 40
			let endTime = data.enddate.split(':')
			let end0 = +endTime[0]
			let end1 = 0
			if (endTime[1] === '30') {
				end1 = 0.5
			} else if (endTime[1] === '00') {
				end1 = 0
			} else if (endTime[1] === '59') {
				end1 = 1
			}
			end = (end0 + end1) * 40
			if (start > end) {
				this.flag = null
				return false
			}
			if ((end - start) < 20) {
				this.flag = null
				return false
			}
			let list = this.divList
			for (let i = 0; i < list.length; i++) {
				let time0 = list[i].top
				let time1 = list[i].top + list[i].height
				if ((start < time0 || start === time0) && (end > time1 || end === time1)) {
					this.flag++
				}
				if ((time0 < start || time0 === start) && start < time1) {
					this.flag++
				}
				if (time0 < end && (end < time1 || end === time1)) {
					this.flag++
				}
			}
		},
		timeToScale (list) {
			for (let i = 0; i < list.length; i++) {
				let top = ''
				let height = ''
				let startTime = list[i].startdate.split(':')
				let start0 = +startTime[0]
				let start1 = 0
				if (startTime[1] === '00') {
					start1 = 0
				} else if (startTime[1] === '30') {
					start1 = 0.5
				}
				top = (start0 + start1) * 40
				let endTime = list[i].enddate.split(':')
				let end0 = +endTime[0]
				let end1 = 0
				if (endTime[1] === '30') {
					end1 = 0.5
				} else if (endTime[1] === '00') {
					end1 = 0
				} else if (endTime[1] === '59') {
					end1 = 1
				}
				height = ((end0 + end1) - (start0 + start1)) * 40
				let params = {
					startdate: list[i].startdate,
					enddate: list[i].enddate,
					top: top,
					height: height
				}
				this.divList.push(params)
			}
		},
		divDel (index) {
			this.$confirm('确认删除', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				this.divList.splice(index, 1)
			}).catch(action => {})
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		}
	}
}
</script>
<style lang="stylus" scoped>

.receivingTime-body{
    display: flex;
    min-width :1000px;
    width :100%;
	flex-direction: column;
    height :100%;
    overflow-y :auto;
    padding-bottom :50px;
    .time-box{
		text-align :left;
        padding :10px 10px 10px 40px
        height :50px
        line-height 50px
        .select-box{
            width :100px;
            margin-left :5px
            margin-right :5px
        }
    }
    .line-box{
		padding:10px 10px 10px 40px;
		.pic-box{
			margin-right:20px;
			float:left;
			width :130px;
			height :100%;
			position relative
			.midNight-box{
				padding-left :10px;
				position:absolute;
				top:0px;
				float:left;
				width :130px;
				height:30px
			}
			.beforeDawn-box{
				position:absolute;
				top:200px;
				padding-left :10px;
				float:left;
				width :130px;
				height:30px
			}
			.day-box{
				position:absolute;
				top:480px;
				padding-left :10px;
				float:left;
				width :130px;
				height:30px
			}
			.night-box{
				position:absolute;
				top:880px;
				padding-left :10px;
				float:left;
				width :130px;
				height:30px
			}
		}
        .left{
			margin-top:5px;
            float:left;
            .el-timeline-item{
                height 60px !important
            }
            width :50px
        }
        .mid{
            float:left;
            margin-top:13px;
            margin-left :20px;
            position: relative;
            width:5px;
        }
        .right{
			color:var(--fx-primary-color);
            float:left;
            margin-top:13px;
            margin-left :20px;
            position: relative;
            width:260px;
        }
    }
	.button-box{
		margin-bottom 20px
	}
}

</style>
<style lang="stylus">
.receivingTime-body {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
